const SET_TRANSLATIONS = 'polyglot//SET_TRANSLATIONS'
const REPLACE_TRANSLATIONS = 'polyglot//REPLACE_TRANSLATIONS'
const REMOVE_TRANSLATIONS = 'polyglot//REMOVE_TRANSLATIONS'

export {
  SET_TRANSLATIONS,
  REPLACE_TRANSLATIONS,
  REMOVE_TRANSLATIONS
}
